import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LandingPageComponent } from "./Module/Navigation/landing-page/landing-page.component";
import { LoginComponent } from "./Module/Main/login/login.component";
import { AuthenticationGuard } from "./Guard/authentication.guard";
import {
  hasRoleGuard,
  RoutePermissionRestriction,
} from "./Guard/has-role.guard";
import { FooterComponent } from "./Module/Navigation/footer/footer.component";
import { isLoggedInGuard } from "./Guard/is-logged-in.guard";
import { ForgotComponent } from "./Module/Main/forgot-password/forgot.component";
import { ResetComponent } from "./Module/Main/reset-password/reset.component";
import { getInTouchComponent } from "./Module/Navigation/get-in-touch/get-in-touch.component";
import { PartnerComponent } from "./Module/Navigation/our-partner/partner.component";
import { FaqComponent } from "./Module/Navigation/faq/faq.component";
import { DaDemandNoticeComponent } from "./Shared/shared/notices/da-demand-notice/da-demand-notice.component";
import { NonTaxDemandNoticeComponent } from "./Shared/shared/notices/non-tax-demand-notice/non-tax-demand-notice.component";
import { ChartTestComponent } from "./Shared/shared/notices/chart-test/chart-test.component";
import { Privileges } from "./Shared/privileges.enum";
import { VerificationLandingComponent } from "./Module/Navigation/vefification/verification-landing/verification-landing.component";
import { VerificationResultComponent } from "./Module/Navigation/vefification/verification-result/verification-result.component";
import { TaxClearanceComponent } from "./Module/Navigation/tax-clearance/tax-clearance.component";
import { SupportResourcesComponent } from "./Module/Navigation/support-resources/support-resources/support-resources.component";
import { ForTestingComponent } from "./Module/Navigation/for-testing/for-testing.component";
import { DemandNoticePaymentComponent } from "./Module/demand-notice-payment/demand-notice-payment.component";
import { AsinPaymentPageComponent } from "./Module/Main/asin-payment-page/asin-payment-page.component";
import { AppLoaderComponent } from "./Shared/shared/app-loader/app-loader.component";
import { SearchMdaServicesComponent } from "./Module/Main/search-mda-services/search-mda-services.component";
import { SearchMdaBillHistoryComponent } from "./Module/Main/search-mda-bill-history/search-mda-bill-history.component";
import { PrintReceiptComponent } from "./Module/Navigation/payments-history/print-receipt/print-receipt.component";
import {
  CreateAsinLandingComponent
} from "./Module/Navigation/create-asin/create-asin-landing/create-asin-landing.component";
import { IndividualDataComponent } from "./Module/Navigation/create-asin/individual-asin/individual-data/individual-data.component";
import { VerifyCodeComponent } from "./Module/Navigation/create-asin/individual-asin/verify-code/verify-code.component";
import {
  SuccessScreenComponent
} from "./Module/Navigation/create-asin/individual-asin/success-screen/success-screen.component";
import {
  BasicInformationComponent
} from "./Module/Navigation/create-asin/individual-asin/basic-information/basic-information.component";
import {
  CaptureImageComponent
} from "./Module/Navigation/create-asin/individual-asin/capture-image/capture-image.component";
import { CameraTestingComponent } from "./Shared/shared/camera-testing/camera-testing.component";
import {
  CorporateDataComponent
} from "./Module/Navigation/create-asin/corporate-asin/corporate-data/corporate-data.component";
import {
  VerificationCodeComponent
} from "./Module/Navigation/create-asin/corporate-asin/verification-code/verification-code.component";
import {
  VerifyMethodComponent
} from "./Module/Navigation/create-asin/corporate-asin/verify-method/verify-method.component";
import {
  CorporateInformationComponent
} from "./Module/Navigation/create-asin/corporate-asin/corporate-information/corporate-information.component";
import {
  SuccessContinueComponent
} from "./Module/Navigation/create-asin/corporate-asin/success-continue/success-continue.component";
import {
  IndividualLandingComponent
} from "./Module/Navigation/create-asin/individual-asin/individual-landing/individual-landing.component";
import {
  CorporateLandingComponent
} from "./Module/Navigation/create-asin/corporate-asin/corporate-landing/corporate-landing.component";
import {
  AsinGenerationComponent
} from "./Module/Navigation/create-asin/individual-asin/asin-generation/asin-generation.component";
import { PublicAsinSearchComponent } from "./Module/Main/public-asin-search/public-asin-search.component";
import { CreateBillsPublicComponent } from "./Module/Main/mda/create-bills-public/create-bills-public.component";
import { InformalLandingComponent } from "./Module/Navigation/create-asin/corporate-asin/informal-landing/informal-landing.component";
import { InformalAsinFormComponent } from "./Module/Navigation/create-asin/corporate-asin/informal-landing/informal-asin-form/informal-asin-form.component";
import { InvoicePaymentPage } from "./Module/Main/invoice-payment-page/invoice-payment-page.component";
import {
  UserManagementInformalComponent
} from "./Module/Admin/user-management-informal/user-management-informal.component";
import { AdminUserProfileComponent } from "./Module/Admin/admin-user-profile/admin-user-profile.component";
import { AuditTrailsComponent } from "./Module/Admin/audit/audit-trails/audit-trails.component";
import { VerificationComponent } from "./Module/Admin/verifications/verification/verification.component";
import {
  PaymentReconciliationComponent
} from "./Module/Admin/reconciliations/payment-reconciliation/payment-reconciliation.component";
import {
  PaymentCheckStatusComponent
} from "./Module/Admin/reconciliations/payment-check-status/payment-check-status.component";
import {
  PaymentCheckStatusPublicComponent
} from "./Module/Admin/reconciliations/payment-check-status-public/payment-check-status-public.component";
import { FormPageComponent } from "./Module/Main/form-page/form-page.component";
import {TamaLandingComponent} from "./Module/Navigation/tama-landing/tama-landing.component";
import { TaasLandingComponent } from "./Module/Navigation/taas-landing/taas-landing.component";
import { UserBillsComponent } from "./Module/Navigation/user-bills/user-bills.component";
import { VaidsSplashPageComponent } from "./Module/Users/vaids/vaids-splash-page/vaids-splash-page.component";
import { PropertyPaymentPageComponent } from "./Module/Main/property-payment-page/property-payment-page.component";

const routes: Routes = [
  {
    path: "for-testing",
    component: CameraTestingComponent,
    pathMatch: "full",
  },
  {
    path: "",
    component: LandingPageComponent,
    pathMatch: "full",
  },
  {
    path: "auth/login",
    component: LoginComponent,
    pathMatch: "full",
    canActivate: [isLoggedInGuard],
  },
  {
    path: "public",
    children: [
      {
        path: "payment",
        component: AsinPaymentPageComponent,
        pathMatch: "full",
      },
      {
        path: "invoice-payment",
        component: InvoicePaymentPage,
        pathMatch: "full",
      },
      {
        path: "property-payment",
        component: PropertyPaymentPageComponent,
        pathMatch: "full",
      },
    ]
  },
  {
    path: "getInTouch",
    component: getInTouchComponent,
  },
  {
    path: "support-and-resources",
    component: SupportResourcesComponent,
  },
  {
      path: "tama",
      component: TamaLandingComponent,
  },
  {
      path: "taas",
      component: TaasLandingComponent,
  },
  {
      path: "tama/registration",
      loadChildren: () =>
          import("./Module/tama-self-service/tama-self-service.module").then(
              (m) => m.TamaSelfServiceModule,
          ),
  },
  {
    path: "vaids",
    component: VaidsSplashPageComponent,
  },
  {
    path: "create-asin",
    component: CreateAsinLandingComponent,
  },
  {
    path: "create-asin/individual",
    component: IndividualLandingComponent,
  },
  {
    path: "create-asin/informal",
    component: InformalAsinFormComponent,
  },
  {
    path: "create-asin/corporate",
    component: CorporateLandingComponent,
  },
  {
    path: "create-asin/verify-code",
    component: VerifyCodeComponent,
  },
  {
    path: "create-asin/success",
    component: SuccessScreenComponent,
  },
  {
    path: "create-asin/basic-information",
    component: BasicInformationComponent,
  },
  {
    path: "create-asin/capture-image",
    component: CaptureImageComponent,
  },
  {
    path: "create-asin/contact-info",
    component: CorporateDataComponent,
  },
  {
    path: "create-asin/verification-method",
    component: VerifyMethodComponent,
  },
  {
    path: "asin/search",
    component: PublicAsinSearchComponent,
  },

  {
    path: "create-asin/verification-code",
    component: VerificationCodeComponent,
  },
  {
    path: "create-asin/code-successful",
    component: SuccessContinueComponent,
  },
  {
    path: "create-asin/success/:id",
    component: AsinGenerationComponent,
  },
  {
    path: "create-asin/corporate-information",
    component: CorporateInformationComponent,
  },
  {
    path: "tax-clearance",
    component: TaxClearanceComponent,
  },
  {
    path: "auth/forgot",
    component: ForgotComponent,
    pathMatch: "full",
  },
  {
    path: "auth/reset",
    component: ResetComponent,
    pathMatch: "full",
  },
  {
    path: "user",
    loadChildren: () =>
      import("./Module/Users/users.module").then((m) => m.UsersModule),
    canActivate: [AuthenticationGuard, hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: [
            Privileges.COMPANY,
            Privileges.INDIVIDUAL,
            Privileges.CAN_VIEW_TAMA,
            Privileges.CAN_VIEW_TAAS,
          ],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: "admin",
    loadChildren: () =>
      import("./Module/Admin/admin.module").then((m) => m.AdminModule),
    canActivate: [AuthenticationGuard, hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: "mda",
    loadChildren: () =>
      import("./Module/mda/mda.module").then((m) => m.MdaModule),
    canActivate: [AuthenticationGuard, hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: [Privileges.MDA],
        },
      ] as RoutePermissionRestriction[],
    },
  },
  {
    path: "payment",
    loadChildren: () =>
      import("./Module/payment/payment.module").then((m) => m.PaymentModule),
  },
  {
    path: "airs",
    loadChildren: () =>
      import("./Module/AIRS/airs.module").then((m) => m.AIRSModule),
    canActivate: [AuthenticationGuard],
  },
  {
    path: "executive",
    loadChildren: () =>
      import("./Module/executive/executive.module").then((m) => m.ExecutiveModule),
    canActivate: [],
  },
  {
    path: "part",
    component: PartnerComponent,
    canActivate: [AuthenticationGuard, hasRoleGuard],
  },
  {
    path: "faq",
    component: FaqComponent,
  },
  {
    path: "da-demand-notice/:assessmentId",
    component: DaDemandNoticeComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: "nt-demand-notice/:assessmentId",
    component: NonTaxDemandNoticeComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: "chart",
    component: ChartTestComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: "chart2",
    component: DemandNoticePaymentComponent,
    canActivate: [AuthenticationGuard],
  },
  {
    path: "verification-landing",
    component: VerificationLandingComponent,
    pathMatch: "full",
    canActivate: [isLoggedInGuard],
  },
  {
    path: "verification-view/:type/:id",
    component: VerificationResultComponent,
    pathMatch: "full",
    canActivate: [isLoggedInGuard],
  },
  {
    path: "general/bill-history",
    component: SearchMdaBillHistoryComponent,
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN, Privileges.MDA]
        }
      ] as RoutePermissionRestriction[]
    },
    pathMatch: "full",
    canActivate: [AuthenticationGuard]
  },
  {
    path: "general/mda/bills",
    component: CreateBillsPublicComponent,
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN, Privileges.MDA]
        }
      ] as RoutePermissionRestriction[]
    },
    pathMatch: "full",
  },
  {
    path: "general/mda",
    component: SearchMdaServicesComponent,
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN, Privileges.MDA]
        }
      ] as RoutePermissionRestriction[]
    },
    pathMatch: "full",
  },
  {
    path: "print-receipt",
    component: PrintReceiptComponent,
    pathMatch: "full",
    canActivate: [isLoggedInGuard],
  },

  {
    path: "general/user-management-informal", component: UserManagementInformalComponent,
    canActivate: [AuthenticationGuard, hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN, Privileges.MDA]
        }
      ] as RoutePermissionRestriction[]
    },
  }, {
    path: "general/user-profile",
    component: AdminUserProfileComponent,
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN, Privileges.MDA]
        }
      ] as RoutePermissionRestriction[]
    },
  },
  {
    path: "general/audit-trail", component: AuditTrailsComponent,
    canActivate: [AuthenticationGuard, hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN, Privileges.MDA]
        }
      ] as RoutePermissionRestriction[]
    },
  },
  {
    path: "general/verification", component: VerificationComponent,
    canActivate: [hasRoleGuard],
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN, Privileges.MDA]
        }
      ] as RoutePermissionRestriction[]
    },
  },
  {
    path: "general/reconciliations/payment-reconciliation",
    component: PaymentReconciliationComponent,
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN, Privileges.MDA]
        }
      ] as RoutePermissionRestriction[]
    },
  }, {
    path: "general/reconciliations/payment/check-status",
    component: PaymentCheckStatusComponent,
    data: {
      permissions: [
        {
          permissions: [Privileges.ADMIN, Privileges.MDA]
        }
      ] as RoutePermissionRestriction[]
    },
  },
  {
    path: 'form',
    component: FormPageComponent
  },
  {
    path: 'user-bills',
    component: UserBillsComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
